import type { JobStatus } from "./schemas/job";

export const JOB_STATUS_LABELS: Record<JobStatus, string> = {
  active: "Active",
  complete: "Complete",
  archived: "Archived",
};

export type JobSiteStatusAction = {
  nextStatus: JobStatus;
  label: string;
  confirmTitle: string;
  confirmMessage: string;
  destructive?: boolean;
};

export function jobSiteStatusActions(
  current: JobStatus,
): JobSiteStatusAction[] {
  switch (current) {
    case "active":
      return [
        {
          nextStatus: "complete",
          label: "Mark complete",
          confirmTitle: "Mark site complete?",
          confirmMessage:
            "The site stays in your list with a Complete status. You can reopen it anytime.",
        },
        {
          nextStatus: "archived",
          label: "Archive site",
          confirmTitle: "Archive this site?",
          confirmMessage:
            "Archived sites are hidden from most lists. Photos stay on file.",
          destructive: true,
        },
      ];
    case "complete":
      return [
        {
          nextStatus: "active",
          label: "Mark active",
          confirmTitle: "Mark site active?",
          confirmMessage: "The site will show as active again for your crew.",
        },
        {
          nextStatus: "archived",
          label: "Archive site",
          confirmTitle: "Archive this site?",
          confirmMessage:
            "Archived sites are hidden from most lists. Photos stay on file.",
          destructive: true,
        },
      ];
    case "archived":
      return [
        {
          nextStatus: "active",
          label: "Restore to active",
          confirmTitle: "Restore this site?",
          confirmMessage: "The site will appear as active for your crew again.",
        },
      ];
    default:
      return [];
  }
}
